<template>
  <vx-card no-shadow>

    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onClickSubmit)" autocomplete="off">

        <div class="vx-row mb-3">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="is_process_allergen" name="is_process_allergen" rules="" v-slot="{ errors }">
              <small class="label">7.1  Does the site process or manufacture any known allergens?</small>
              <vs-switch v-model="form.is_process_allergen" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_process_allergen" vid="is_process_allergen_text" name="is_process_allergen_text" rules="required" v-slot="{ errors }">
              <small class="label">If yes,please specify</small>
              <vs-input type="text" name="is_process_allergen_text" class="w-full" v-model="form.is_process_allergen_text" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-full w-full md:mb-0">
            <ValidationProvider v-if="form.is_process_allergen" vid="process_allergen_file" name="process_allergen_file" rules="" v-slot="{ errors }">
              <small class="label">Please attach a copy of your allergen policy and outline procedures which are in place to manage cross contamination risks.(file)</small>
              <a target="_blank" v-if="form.process_allergen_file" class="float-right" :href="form.process_allergen_file">view file</a>
              <vs-input @change="onUploadPolicyFile($event)" type="file" name="process_allergen_file" class="w-full" />    <!-- enviromental_policy_file -->
              <span v-if="formUploadRequired001" class="text-danger text-sm">This field is required</span>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3 mt-8">
          <div class="vx-col md:w-1/2 md:mb-0">
            <ValidationProvider vid="is_risk_assessment" name="is_risk_assessment" rules="" v-slot="{ errors }">
              <small class="label">7.2 Has a full risk assessment taken place to determine the risk of cross contamination during production and transport and the necessary controls put in place?</small>
              <vs-switch v-model="form.is_risk_assessment" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider v-if="form.is_risk_assessment" vid="is_risk_assessment_text" name="is_risk_assessment_text" rules="" v-slot="{ errors }">
              <small class="label">If yes,please specify</small>
              <a target="_blank" v-if="form.is_risk_assessment_text" class="float-right" :href="form.is_risk_assessment_text">view file</a>
              <vs-input @change="onUploadRiskAssessmentFile($event)" type="file" name="is_risk_assessment_text" class="w-full" />
              <span v-if="formUploadRequired002" class="text-danger text-sm">This field is required</span>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="contamination_validated" name="contamination_validated" rules="required" v-slot="{ errors }">
              <small class="label">7.3 How is cross contamination validated?</small>
              <vs-input type="text" name="contamination_validated" class="w-full" v-model="form.contamination_validated" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>



        <div class="flex flex-wrap items-center justify-end">
          <vs-button v-if="status.is_supplier_manufacture_site_allergen_complete === 1"  button="submit" class="ml-auto mt-2">Save and Change</vs-button>
          <vs-button v-else button="submit" class="mt-2 ml-4">Save and Change</vs-button>
          <!--          <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>-->
        </div>
      </form>
    </ValidationObserver>
  </vx-card>

</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  const SupplierRepository = RepositoryFactory.get('supplier');
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  export default {
    name: "SupplierManufacturingEnvironmentDetails",
    data() {
      return {
        form: {
          is_process_allergen: false,
          is_risk_assessment: false
        },
        id: null,
        status: {},
        formUploadRequired001: false,
        formUploadRequired002: false
      }
    },
    mixins: [SuccessMessage, ErrorMessages],
    methods: {
      onClickNext() {
        this.$emit('notify', 1)
      },
      onClickSubmit() {
        this.status.is_supplier_manufacture_site_allergen_complete === 1 ? this.onClickUpdate() : this.onClickCreate()
      },
      async onClickUpdate() {
        if (this.form.is_process_allergen && !this.form.process_allergen_file) {
          this.formUploadRequired001 = true
        } else if((this.form.is_risk_assessment && !this.form.is_risk_assessment_text)){
          this.formUploadRequired002 = true
        } else{
          this.$vs.loading()
          try {
            const data= (await SupplierManufactureRepository.UpdateManufactureAllergensDetails(this.id, this.form))
            this.showSuccessMessage('Manufacture Allergens Details Updated!')
            this.onClickNext()
          }catch (e) {
            this.convertAndNotifyError(e)
          }
          this.$vs.loading.close()
        }
      },
      async onClickCreate() {
        if (this.form.is_process_allergen && !this.form.process_allergen_file) {
          this.formUploadRequired001 = true
        } else if((this.form.is_risk_assessment && !this.form.is_risk_assessment_text)){
          this.formUploadRequired002 = true
        } else{
          this.$vs.loading()
          try {
            const data= (await SupplierManufactureRepository.CreateManufactureAllergensDetails(this.form))
            this.showSuccessMessage('Manufacture Allergens Details Created!')
            this.onClickNext()
          }catch (e) {
            this.convertAndNotifyError(e)
          }
          this.$vs.loading.close()
        }
      },

      async loadData() {
        this.$vs.loading()
        const {data} = (await SupplierManufactureRepository.getManufactureAllergensDetails(this.id)).data
        this.form =data
        this.$vs.loading.close()
      },
      async loadStatus() {
        this.$vs.loading()
        const {data} = (await SupplierManufactureRepository.getManufactureSiteStatus(this.id)).data
        this.status =data
        this.$vs.loading.close()
      },
      async onUploadPolicyFile(event) {
        this.$vs.loading();
        try {
          const file = await event.target.files[0]
          let formData = new FormData();
          formData.append('file', file);
          this.form.process_allergen_file = (await SupplierRepository.uploadFile(formData)).data.data.file
          this.formUploadRequired001 = false
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async onUploadRiskAssessmentFile(event) {
        this.$vs.loading();
        try {
          const file = await event.target.files[0]
          let formData = new FormData();
          formData.append('file', file);
          this.form.is_risk_assessment_text = (await SupplierRepository.uploadFile(formData)).data.data.file
          this.formUploadRequired002 = false
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
    },
    async mounted() {
      this.id = this.$route.params.id
      this.form.supplier_manufacture_site_id =  this.id
      await this.loadStatus()
      if (this.status.is_supplier_manufacture_site_allergen_complete === 1 ) {
        await this.loadData()
      }
    }

  }
</script>

<style scoped>

</style>
